import { Dialog } from '@tamagui/dialog';

export const ModalOverlay = () => (
  <Dialog.Overlay
    key="overlay"
    // @ts-expect-error We have a custom backgroundColor prop
    backgroundColor="rgba(34, 39, 49, 0.50)"
    animateOnly={['opacity']}
    animation={[
      'quick',
      {
        opacity: {
          overshootClamping: true,
        },
      },
    ]}
    enterStyle={{ opacity: 0 }}
    exitStyle={{ opacity: 0 }}
  />
);
